/**
 * Staging-only bypass for creator onboarding (email gate + Didit identity).
 * Enable on staging by setting:
 *   REACT_APP_SKIP_CREATOR_ONBOARDING_CHECKS=true
 *
 * Never set this in production.
 */
export function isStagingCreatorOnboardingBypassEnabled(): boolean {
  return (
    String(process.env.REACT_APP_SKIP_CREATOR_ONBOARDING_CHECKS || "")
      .toLowerCase()
      .trim() === "true"
  );
}

/** Matches Didit API casing used in onboarding step 3 UI checks. */
export const STAGING_MOCK_VERIFICATION_STATUS = "Approved";

/** Mock Didit payload so step 3 treats identity as approved without iframe/Cloudflare. */
export const STAGING_MOCK_DIDIT_VERIFICATION_DATA = {
  success: true,
  didit_verifications: [
    {
      status: STAGING_MOCK_VERIFICATION_STATUS,
      session_url: null,
    },
  ],
} as const;

/** Extra profile fields when completing creator onboarding under staging bypass. */
export function getCreatorOnboardingFinalizeFields(): Record<string, unknown> {
  if (!isStagingCreatorOnboardingBypassEnabled()) {
    return {};
  }
  return { ageProofed: true };
}
